
export function percentPassiveCellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable, props, listOfHeaderRows) {
    if (col == 0) {
        td.innerHTML = '% Passive'
        td.className = td.className + "cellNA"
        cellProperties.readOnly = true;
        td.className = "readOnlyCell";
    }
   
    return cellProperties

}